(function () {
    'use strict';
    angular
        .module('app')
        .controller('SearchCtrl', SearchCtrl);

    function SearchCtrl($scope, $rootScope, $timeout, $state, $stateParams, $location, $filter,
        toaster, $localStorage, BrandService, SeasonService, SharedData, PermissionService,
        LinePlanService, UserPreferenceService, BriefService, PatternService, PrototypeService,
        ExportService, DocumentService, GridUtil, cfpLoadingBar, QUtil) {

        //---Variable Declarations---

        var model = this;
        $scope.stateChanged = false;
        $scope.gridChanged = false;
        $scope.changed = function (data) {
            $scope.gridChanged = data;
        }
        $scope.permissionDenied = function () {
            $state.go('permissionDenied');
        }

        $scope.goToUserPage = function (data) {
            $state.go(data.pageName, data.params);
        }

        $scope.loaderClosed = function () {
            cfpLoadingBar.complete();
        }

        $scope.loaderStart = function () {
            cfpLoadingBar.start();
        }
        $scope.GridUtil = GridUtil;
        $scope.currentUser = $rootScope.globals.currentUser;
        $scope.stateParams = $stateParams;
        $scope.isFactoryUser = $rootScope.globals.currentUser.isFactoryUser;
        $scope.totalRecords = 0;
        $scope.brands = [];
        $scope.seasons = [];
        $scope.productlines = [];
        $scope.divisions = [];
        $scope.lastnames = [];
        $scope.developmenttypes = [];
        $scope.constructions = [];
        $scope.hierarchyCodes = [];
        $scope.factories = [];
        $scope.productTypes = [];
        $scope.resumeState = 'null';

        $scope.newReport = {};
        $scope.newReport.SeasonId = null;
        $scope.currentReportState = null;
        $scope.UserPreferenceId = 0;
        $scope.userDefinedReports = [];


        $scope.defaultSearchModule = function () {
            var module = parseInt($stateParams.searchModule);

            if (isNaN(module))
                return 0;

            return module;
        };

        const defaultPageNumber = 1;
        const defaultPageSize = 50;
        const defaultReportModel = {
            name: '',
            searchTerms: {
                pageSize: defaultPageSize,
                pageNumber: defaultPageNumber,
                sortColumn: '',
                sortDirection: '',
            },
            columnsHidden: [],
            columnsOrder: [],
            exec: false,
            Id: 0,
            searchType: 1, //1 for search, 2 for CP search
            searchModule: $scope.defaultSearchModule()
        };

        $scope.reportModel = angular.copy(defaultReportModel);
        $scope.lastReportModel = null;
        $scope.typeArray = ['Line Plan', 'Brief', 'Pattern', 'Colorway'];
        $scope.pagingOptions = [15, 25, 50, 100];

        $scope.$on('$stateChangeStart', handleNavigation);

        $scope.showGrid = false;


        var gridOptions = {
            rowData: null,
            enableColResize: true,
            enableFilter: false,
            enableSorting: true,
            paginationPageSize: $scope.reportModel.pageSize,
            suppressContextMenu: true,
            suppressMultiSort: true,
            suppressSorting: false,
            suppressDragLeaveHidesColumns: true,
            suppressMovableColumns: false,
            suppressRowHoverClass: true,
            suppressColumnMoveAnimation: true,
            showToolPanel: false,
            overlayLoadingTemplate: '<div id="mini-loader"></div>',

            onSortChanged: function (e) {
                //sortObj is a singleton array containing an object of the form {colId:"foo", sort:"bar"}
                var sortObj = gridOptions.api.getSortModel();
                $scope.reportModel.searchTerms.sortColumn = sortObj.length ? sortObj[0].colId : "";
                $scope.reportModel.searchTerms.sortDirection = sortObj.length ? sortObj[0].sort : "";

                createSaveCookie(true);
                $scope.runService(false, true);
            },

            onColumnVisible: function (e) {
                updateColumnListsFromGrid();

                createSaveCookie(true);

                gridOptions.api.resetRowHeights();
            },

            getRowHeight: function (params) {
                $scope.gridRowHeight = GridUtil.getRowHeight(params, $scope.columnDefs, 30, 76, 200);
                return $scope.gridRowHeight;
            },

            onColumnMoved: function (e) {
                $scope.newIndex = e.toIndex;
                $scope.newIndexName = e.column.colId;
            },

            onDragStopped: function () {
                var columnsOrder = $scope.reportModel.columnsOrder;
                var index = columnsOrder.map(function (e) { return e.colId; }).indexOf($scope.newIndexName);

                var newVal = { idx: $scope.newIndex, colId: $scope.newIndexName };
                if (index < 0) {
                    columnsOrder.push(newVal);
                } else {
                    columnsOrder[index] = newVal;
                }

                createSaveCookie(true);
            }
        };

        function getSavedSearches(getAfterSave) {
            return UserPreferenceService.getUserPreferenceSearch(1).then(function (response) {
                //Response provides an array of all saved report objects from the db
                if (response) {
                    $scope.userDefinedReports = [];
                    angular.forEach(response, function (k, v) {
                        k.searchTerms = JSON.parse(k.searchTerms);
                        k.columnsHidden = JSON.parse(k.columnsHidden);
                        k.columnsOrder = JSON.parse(k.columnsOrder);
                        k.typeName = $scope.typeArray[k.searchModule - 1];
                        k.changedOn = k.changedOn || k.createdOn;
                        if (getAfterSave) {
                            if ($scope.newReportName == k.name) {
                                $scope.reportName = $scope.newReportName;
                                $scope.reportModel.Id = k.Id;
                            }
                        }
                        $scope.userDefinedReports.push(k);
                    });

                    if (getAfterSave) {
                        createSaveCookie(true);
                    }
                }
            });
        } 

        //QUtil.whenAll([
        //    function () { return PatternService.getProductLineList().then(function (response) { $scope.productlines = response; }); },
        //    function () { return PatternService.getAllDevelopmentTypeList().then(function (response) { $scope.developmenttypes = response; }); },
        //    function () { return PatternService.getConstructions().then(function (response) { $scope.constructions = response; }); },
        //    function () { return PrototypeService.getProductTypes().then(function (response) { $scope.productTypes = response; }); },
        //    function () { return BrandService.getBrandsByUser().then(function (response) { $scope.brands = response; }); },
        //    function () { return PrototypeService.getDivisions(0).then(function (response) { $scope.divisions = response; }); },
        //    function () { return PrototypeService.getRegionList().then(function (data) { $scope.regions = data; }); },
        //    function () { return PrototypeService.getWidthList().then(function (data) { $scope.widths = data; }); },
        //    function () { return getSavedSearches(); }
        //]).then(function () {
        //    SharedData.getUserDefaults().then(function (userDefaults) {
        //        if (userDefaults) {
        //            if (userDefaults.brandId === 0)
        //                userDefaults.brandId = null;

        //            if (userDefaults.seasonId === 0)
        //                userDefaults.seasonId = null;

        //            $scope.defaultBrandId = userDefaults.brandId;
        //            $scope.defaultSeasonId = userDefaults.seasonId;
        //            $scope.defaultDivisionKey = userDefaults.divisionKey;

        //            //Ensure that default season id is valid
        //            SeasonService.getSeasonsByBrand($scope.defaultBrandId).then(function (seasons) {
        //                if (seasons) {
        //                    if (seasons.length > 0)
        //                        $scope.seasons = seasons;
        //                    if (!($scope.defaultSeasonId > -1 && checkSeasonArray($scope.defaultSeasonId))) {
        //                        $scope.defaultSeasonId = null;
        //                        $scope.defaultDivisionKey = null;
        //                    }
        //                }
        //            });

        //            var module = $scope.defaultSearchModule();
        //            if (module > 0 && $stateParams.quickSearchText) {
        //                $scope.reportModel.searchTerms.quickSearchText = decodeURIComponent($stateParams.quickSearchText);


        //                if (userDefaults.useDefaultsInQuickSearch === true) {
        //                    $scope.reportModel.searchTerms.brandId = userDefaults.brandId;
        //                    $scope.reportModel.searchTerms.seasonId = userDefaults.seasonId;
        //                    $scope.reportModel.searchTerms.divisionKey = userDefaults.divisionKey;
        //                }

        //                var rpt = {
        //                    searchModule: module,
        //                    name: $scope.reportName
        //                }

        //                $scope.getSearchForm(rpt, $scope.reportModel.exec, true);
        //                cfpLoadingBar.start();
        //                $scope.runReport();
        //            }
        //            else if (!$localStorage.ss) {
        //                //cfpLoadingBar.start();
        //                defaultBrandAndSeason();
        //                //setTimeout(() => {
        //                  //  cfpLoadingBar.complete();

        //    //            },2000);
        //            }
        //            else {
        //                updateReportModelFromCookie();
        //                var rpt = {
        //                    searchModule: $scope.reportModel.searchModule,
        //                    name: $scope.reportModel.name,
        //                    Id: $scope.reportModel.Id
        //                }
        //                $scope.getSearchForm(rpt, $scope.reportModel.exec, true);
        //                cfpLoadingBar.complete();
        //            }
        //        }
        //    });
        //});

        //UserPreferenceService.getUserPreferences('SortSavedSearches').then(function (response) {
        //    var data = response[0];
        //    if (data) {
        //        var preference = eval('(' + data.PreferenceValue + ')');
        //        $scope.savedSearchPreference = preference;
        //        $scope.savedSearchPreferenceId = data.UserPreferenceId;
        //        setSortSavedSearches();
        //    } else {
        //        $scope.savedSearchPreference = ['changedOn', false];

        //    }
        //});

        $scope.getSeason = function (brand, keepSeason) {
            if (brand) {
                SeasonService.getSeasonsByBrand(brand).then(function (response) {
                    if (response) {
                        $scope.seasons = response;
                        if (!keepSeason && $scope.defaultSeasonId > -1 && checkSeasonArray($scope.defaultSeasonId)) {
                            $scope.newReport.SeasonId = $scope.defaultSeasonId;
                            $scope.reportModel.searchTerms.SeasonId = $scope.defaultSeasonId;
                        }
                    }
                });
            }
            else {
                $scope.seasons = [];
                $scope.newReport.SeasonId = null;
            }
        };

        $scope.runReport = function () {
            if ($scope.lineSearchForm.$dirty || $scope.briefSearchForm.$dirty || $scope.patternSearchForm.$dirty || $scope.colorwaySearchForm.$dirty) {
                $scope.reportModel.searchTerms.BrandId = $scope.newReport.BrandId;
                $scope.reportModel.searchTerms.SeasonId = $scope.newReport.SeasonId;
            }

            $scope.newReport.pageNumber = 1;

            cfpLoadingBar.start();

            //gridOptions.rowHeight = 76;

            switch ($scope.reportModel.searchModule) {
                case 1:
                    //running Line Plan report
                    // gridOptions.rowHeight = 30; //set row height without images
                    gridOptions.onRowClicked = function (event) {
                        if (!event.event.ctrlKey && !event.event.altKey) {
                            $state.go('linePlan', { 'linePlanId': event.data.LinePlanId });
                        }

                        if (event.event.ctrlKey) {
                            window.open(window.location.origin + '/linePlan/' + event.data.LinePlanId, '_blank');
                        }

                        if (event.event.altKey) {
                            $scope.getChildData(1, event.data.LinePlanId, event.data.LinePlanName);
                        }
                    };
                    break;
                case 2:
                    //running Brief report
                    gridOptions.onRowClicked = function (event) {
                        if (!event.event.ctrlKey && !event.event.altKey) {
                            $state.go('brief', { 'briefSeasonalId': event.data.BriefSeasonalId });
                        }

                        if (event.event.ctrlKey) {
                            window.open(window.location.origin + '/brief/' + event.data.BriefSeasonalId, '_blank');
                        }

                        if (event.event.altKey) {
                            $scope.getChildData(2, event.data.BriefSeasonalId, event.data.Name);
                        }
                    };
                    break;
                case 3:
                    //running Pattern report
                    gridOptions.onRowClicked = function (event) {
                        if (!event.event.ctrlKey && !event.event.altKey) {
                            $state.go('pattern', { 'patternSeasonalId': event.data.PatternSeasonalId });
                        }

                        if (event.event.ctrlKey) {
                            window.open(window.location.origin + '/pattern/' + event.data.PatternSeasonalId, '_blank');
                        }

                        if (event.event.altKey) {
                            $scope.getChildData(3, event.data.PatternSeasonalId, event.data.Name);
                        }
                    };
                    break;
                case 4:
                    //running Colorway report
                    gridOptions.onRowClicked = function (event) {
                        if (!event.event.ctrlKey && !event.event.altKey) {
                            $state.go('colorway', { 'prototypeSeasonalId': event.data.PrototypeSeasonalId });
                        }

                        if (event.event.ctrlKey) {
                            window.open(window.location.origin + '/colorway/' + event.data.PrototypeSeasonalId, '_blank');
                        }

                        if (event.event.altKey) {
                            $scope.getChildData(4, event.data.PrototypeSeasonalId, event.data.Name);
                        }
                    };
                    break;
            }
            $scope.showGrid = true;
            $rootScope.refine = $scope.hideResultsPrompt;
            $scope.runService(false);
        };

        $scope.runService = function (excelReport, skipReset) {
            $scope.newReport.sortColumn = $scope.reportModel.searchTerms.sortColumn;
            $scope.newReport.sortDirection = $scope.reportModel.searchTerms.sortDirection;
            $scope.reportModel.searchTerms = angular.copy($scope.newReport);
            createSaveCookie(true); //this must run after the $scope.reportModel.searchTerms is assigned

            var gridDiv = document.querySelector('#myGrid');
            var searchTerms = angular.copy($scope.reportModel.searchTerms);

            var pageNumber = $scope.reportModel.searchTerms.pageNumber;
            var pageSize = $scope.reportModel.searchTerms.pageSize || defaultPageSize;
            var service = $scope.determineSearchService($scope.reportModel.searchModule, excelReport);

            if (!excelReport && gridDiv.children.length > 0) {
                gridOptions.api.showLoadingOverlay();
            }

            var sortCol = _.find($scope.columnDefs, function (def) { return def.field === searchTerms.sortColumn });
            if (sortCol && sortCol.sortName)
                searchTerms.sortColumn = sortCol.sortName;

            if (excelReport) {
                searchTerms.hiddenCols = $scope.reportModel.columnsHidden;

                if (gridOptions.columnApi) {
                    searchTerms.columnOrder = _.chain(gridOptions.columnApi.getAllColumns())
                        .filter(function (i) {
                            return i.visible;
                        }).sortBy(function (i) {
                            return i.left;
                        })
                        .map(function (i) {
                            return i.colId;
                        }).value();
                }
                pageNumber = 1;
                pageSize = 0;
            }

            service(searchTerms, pageNumber, pageSize, searchTerms.sortColumn, searchTerms.sortDirection)
                .then(
                    function (response) {
                        if (excelReport) {
                            cfpLoadingBar.complete();

                            if (response && response.length > 0)
                                DocumentService.openTempDocument(response, "application/vnd.ms-excel", $scope.reportName + " Export.xlsx");
                            else
                                toaster.pop({ type: 'error', title: 'Error!', body: "An unexpected error occurred exporting the file.", timeout: 5000 });
                            return;
                        }

                        if (!response || response.results.length === 0) {
                            $scope.handleNoSearchResults();
                            return;
                        }

                        var savedReport = angular.copy(_.find($scope.userDefinedReports, function (r) { return r.Id === $scope.reportModel.Id; }));
                        if (!savedReport) {
                            if (!$scope.currentReportState) {

                                $scope.currentReportState = $scope.createUserPreferenceModel(false);

                                if (!skipReset) {
                                    $scope.currentReportState.columnsHidden = [];

                                    angular.forEach(response.columnGroups, function (colGroup) {
                                        angular.forEach(colGroup.columns, function (col) {
                                            if (col.hide) {
                                                $scope.currentReportState.columnsHidden.push(col.field);
                                            }
                                        });
                                    });
                                }
                            }

                            savedReport = $scope.currentReportState;
                        } else {
                            if ($scope.currentReportState) {
                                savedReport.columnsHidden = $scope.currentReportState.columnsHidden;
                            } else {
                                $scope.currentReportState = savedReport;
                            }
                        }
                        var columnsChanged =
                            $scope.lastIncludePatternLevel !== $scope.newReport.IncludePatternLevel ||
                            $scope.lastIncludeBriefLevel !== $scope.newReport.IncludeBriefLevel ||
                            $scope.lastIncludeLinePlanLevel !== $scope.newReport.IncludeLinePlanLevel ||
                            $scope.reportModel.Id !== $scope.lastReportModel ||
                            $scope.columnConfigurationCleared;
                        //get column defs should always happen
                        $scope.columnDefs = $scope.getColumnDefs(savedReport, response);
                        $scope.gridCols = response.columnGroups;
                        if (columnsChanged) {
                            $scope.lastReportModel = $scope.reportModel.Id;
                            $scope.lastIncludePatternLevel = $scope.newReport.IncludePatternLevel;
                            $scope.lastIncludeBriefLevel = $scope.newReport.IncludeBriefLevel;
                            $scope.lastIncludeLinePlanLevel = $scope.newReport.IncludeLinePlanLevel;
                            $scope.columnConfigurationCleared = false;
                        }
                        setScopeLevelSearchInfo(response);
                        setGridSorting($scope.columnDefs);
                        renderGrid(gridDiv, $scope.columnDefs, response.results);
                        handleColumnReordering($scope.reportModel);
                        updateColumnListsFromGrid();
                        if (!skipReset) {
                            resetConfigurationStateTracking();
                        }
                        cfpLoadingBar.complete();
                    },
                    function (errorMsg) {
                        $scope.handleNoSearchResults(errorMsg);
                    }
                );
        };

        $scope.saveReportPopup = function () {
            $scope.newReportName = $scope.reportName;
            $scope.reportNameChanged($scope.reportName);
            $('#saveReportPopup').modal('show');
            $timeout(function () {
                $('#saveReportPopup input[type=text]').focus();
                $('#saveReportPopup input[type=text]').select();
            }, 0);
        };

        $scope.windowGridHeight = function () {
            if (window.outerHeight >= 768) {
                return window.innerHeight - 315;
            } else {
                var size = $scope.totalRecords < $scope.pageSize ? $scope.totalRecords : $scope.pageSize;
                return (size * $scope.gridRowHeight) + 47;
            }
        };

        $scope.canUpload = function (reportType) {
            if ($rootScope.globals.currentUser.isFactoryUser && !$scope.showGrid)
                return false;

            if (reportType === "2")
                return PermissionService.canEditBrief();

            if (reportType === "3")
                return PermissionService.canEditPattern();

            if (reportType === "4")
                return PermissionService.canEditPrototype();

            return false;
        };

        $scope.selectDocBrief = function (e) {
            uploadDoc(e.files[0], 'browse-brief');
        };

        $scope.selectDocPattern = function (e) {
            uploadDoc(e.files[0], 'browse-pattern');
        };

        $scope.selectDocProto = function (e) {
            uploadDoc(e.files[0], 'browse-prototype');
        };

        $scope.setReportModelHiddenColumns = function (columnState) {
            $scope.reportModel.columnsHidden = [];

            angular.forEach(columnState, function (value, i) {
                if (value.hide) {
                    $scope.reportModel.columnsHidden.push(value.colId);
                }

            });
        };

        $scope.getSearchForm = function (rpt, fast, retainModel, basicReport) {
            if (!retainModel) {
                clearReportModel();
            }

            $scope.customReport = false;
            $scope.reportModel.searchModule = parseInt(rpt.searchModule);
            $scope.reportModel.Id = rpt.Id;

            if (!rpt.name) {
                name = $scope.typeArray[rpt.type - 1];
            }

            $scope.reportName = rpt.name;
            $scope.reportModel.name = rpt.name;

            $scope.showGrid = false;
            $scope.isReportOverwrite = false;
            $scope.isNoReportName = false;

            //Determine if we have a saved report, and if so update report model accordingly
            if (rpt.Id && rpt.Id > 0) {
                $scope.customReport = true;
                $scope.isReportOverwrite = true;

                //Ensure userDefinedReports has been populated, otherwise fall back to saved search cookie
                if ($scope.userDefinedReports.length == 0) {
                    updateReportModelFromCookie();
                }
                else {
                    if (!retainModel) //this should only run when asked not to retainModel (onclick)
                    {
                        updateReportModelFromSavedReport(rpt);
                    }
                    $scope.getSeason($scope.reportModel.searchTerms.BrandId, true);
                }

                if ($scope.reportModel.searchTerms && !$scope.reportModel.searchTerms.BrandId) {
                    $scope.seasons = [];
                }
            }
            //We have a basic report (i.e. simply Line Plan)
            else if (basicReport) {
                defaultBrandAndSeason();
            }

            $scope.newReport = {};

            populateSearchCriteria($scope.reportModel.searchTerms);
            createSaveCookie(fast);
            setPristine();

            if (fast) {
                $scope.runReport();
            }
        };

        $scope.hideResultsPrompt = function (e) {
            $scope.isPref = false;
            $scope.isState = false;
            if ($stateParams.searchModule) {
                $location.url('/Search');
            }
            if (stateChangeCheck()) {
                $scope.isPref = true;
                $('#confirmHiddenFields').modal({ backdrop: 'static', keyboard: false });
                $('#confirmHiddenFields').modal('show');
            } else {
                $scope.hideResults();
            }
        };

        $scope.hideResults = function () {
            setPristine();
            createSaveCookie(false);
            $scope.showGrid = false;
            $rootScope.refine = false;
            $scope.preventNoMore = false;
            $scope.currentReportState = null;
        };

        $scope.cellRenderers = {
            'dateParse': GridUtil.dateParse,
            'dateParseNonLocal': GridUtil.dateParseNonLocal,
            'check': GridUtil.check,
            'image': image,
            'percent': GridUtil.percent1,
            'multiline': GridUtil.multiline
        };

        $scope.onHideColumns = function (colKey, hide) {
            gridOptions.columnApi.setColumnVisible(colKey, !hide);
            updateColumnListsFromGrid();

            $scope.currentReportState = $scope.createUserPreferenceModel(false);
        };

        $scope.onBtExport = function (name) {
            cfpLoadingBar.start();
            $scope.runService(true);
        };

        $scope.onBtnBegEnd = function (n) {
            $scope.pageNumber = n;
            $scope.onPageChanged(n);
        };

        $scope.onBtnPrevNext = function (e) {
            $scope.pageNumber = e;
            $scope.onPageChanged(e);
        };

        $scope.onPageChanged = function (e) {
            $scope.newReport.pageNumber = e;
            $scope.runService(false, true);
            createSaveCookie(true);
        };

        $scope.onPageSizeChanged = function (e) {
            $scope.newReport.pageSize = e;
            $scope.newReport.pageNumber = 1;
            $scope.runService(false, true);
            createSaveCookie(true);
        };

        $scope.determineSearchService = function (reportType, isExport) {
            switch (reportType) {
                case 1:
                    if (isExport)
                        return LinePlanService.exportLinePlans;
                    return LinePlanService.searchLinePlans;
                case 2:
                    if (isExport)
                        return BriefService.exportBriefs;
                    return BriefService.searchBriefs;
                case 3:
                    if (isExport)
                        return PatternService.exportPatterns;
                    return PatternService.searchPatterns;
                case 4:
                    if (isExport)
                        return PrototypeService.exportPrototypes;
                    return PrototypeService.searchPrototypes;
                default:
                    throw new Error('Report Service not supported');
            }
        };

        $scope.getColumnDefs = function (savedReport, response) {
            var columnDefs = [];
            response.columnGroups.totalColumns = response.totalColumns;

            angular.forEach(response.columnGroups, function (colGroup) {
                angular.forEach(colGroup.columns, function (col) {

                    if (savedReport && savedReport.columnsHidden) {
                        col.hide = savedReport.columnsHidden.indexOf(col.field) > -1;
                    }

                    if (col.cellRenderer) {
                        col.cellRendererName = col.cellRenderer;
                        col.cellRenderer = $scope.cellRenderers[col.cellRenderer];
                    }

                    columnDefs.push(col);
                });
            });

            return columnDefs;
        };

        $scope.scrollToStart = function () {

            //get first visible column to reset scroll
            var colScrollTo = '';

            var matchFound = false;

            angular.forEach(gridOptions.columnDefs, function (col) {
                if (!matchFound) {
                    if (col.hide) {
                        return;
                    }
                    matchFound = true;
                    colScrollTo = col.field;
                }
            });

            gridOptions.api.ensureColumnVisible(colScrollTo);
        };

        $scope.excelExport = function (exportToExcelArgs) {
            return ExportService.excelExport(exportToExcelArgs, 1);
        };

        $scope.handleNoSearchResults = function (result) {

            var body = 'No data was found matching this search criteria.',
                timeout = 3000;

            if (typeof result === 'string') {
                body = result;
                timeout = 6000;
            }

            toaster.pop({
                type: 'warning',
                title: 'Alert!',
                body: body,
                timeout: timeout
            });

            $scope.hideResults();
            cfpLoadingBar.complete();
            createSaveCookie(false);
        };

        $scope.getSelected = function (obj) {

            $scope.deleteArray = []; //service uses this array of id's to delete
            $scope.deleteArrayNames = [];

            var daLength = 0;

            angular.forEach(obj, function (k, v) {
                if (k.selected) {
                    daLength++;
                    $scope.deleteArray.push(k.Id);
                    $scope.deleteArrayNames.push(k.name);
                }
            })

            if (daLength > 0) {
                $scope.deleteAll = true;
            } else {
                $scope.deleteAll = false;
            }
        };

        $scope.toggleSelectAll = function () {

            var toggleStatus = $scope.isSelectAll;

            angular.forEach($scope.userDefinedReports, function (itm) {
                itm.selected = toggleStatus;
            });

            $scope.getSelected($scope.userDefinedReports);
        };

        $scope.unSelectAll = function () {

            if ($scope.userDefinedReports.length < 2) {

                angular.forEach($scope.userDefinedReports, function (itm) {
                    itm.selected = false;
                });

                $scope.deleteAll = false;
                model.isSelectAll = false;
            }
        };

        $scope.optionToggled = function () {

            $scope.isSelectAll = $scope.userDefinedReports.every(function (itm) {
                return itm.selected;
            });

            $scope.getSelected($scope.userDefinedReports);
        };

        $scope.deleteSavedSearches = function () {

            var userPreferenceIds = $scope.deleteArray.toString();

            UserPreferenceService.deleteUserPreferenceSearch(userPreferenceIds)
                .then(function () {
                    toaster.pop({
                        type: 'success',
                        title: 'Delete complete!',
                        body: 'Saved Search successfully removed.',
                        timeout: 3000
                    });

                    $scope.deleteAll = false;

                    //clear the userdefined reports
                    angular.forEach($scope.deleteArray, function (key, value) {
                        var index = $scope.userDefinedReports.map(function (e) { return e.Id }).indexOf(key);
                        if (index > -1) {
                            $scope.userDefinedReports.splice(index, 1);
                        }
                    });

                    // if you're on a deleted report, remove cookie, name and fields to avoid any conflict
                    if ($scope.userDefinedReports.length == 0) {
                        $localStorage.ss = null;
                        if ($scope.deleteArrayNames.indexOf($scope.reportName) > -1) {
                            $scope.reportName = '';
                            $scope.reportModel.searchModule = '';
                        }
                    }

                    $scope.newReport = {};

                    //rebuild array
                    $scope.$evalAsync();
                });
        };

        $scope.reportNameChanged = function (name, userPreferenceModel) {
            if (name !== '') {
                $scope.isNoReportName = false;
            }

            //if saved search on the current search
            if ($scope.reportName == name && $scope.reportModel.Id > 0) {
                $scope.isReportOverwrite = true;
            }
            else {
                $scope.isReportOverwrite = false;
            }

            //if not on the saved search
            angular.forEach($scope.userDefinedReports, function (k, v) {
                if (name == k.name) {
                    $scope.isReportOverwrite = true;
                    if (userPreferenceModel)
                        userPreferenceModel.Id = k.Id;
                }
            });
        };

        $scope.saveReport = function () {
            setPristine();

            if (!$scope.newReportName || $scope.newReportName.trim() == '') {
                $scope.isNoReportName = true;
                return;
            }
            $scope.reportModel.name = $scope.newReportName;
            $scope.setReportModelHiddenColumns(gridOptions.columnApi.getColumnState());

            var columnsOrder = $scope.reportModel.columnsOrder;
            var columns = gridOptions.columnApi.getColumnState();

            $scope.reportModel.columnsOrder = []; //clear the reportModel columns order because we are about to rearrange this beast
            angular.forEach(columnsOrder, function (k, v) {
                var index = columns.map(function (e, v) { return e.colId }).indexOf(k.colId);
                if (index > -1) { //only add if index is -1, -1 means it doesnt exist anymore
                    $scope.reportModel.columnsOrder.push({ idx: index, colId: k.colId })
                }
            });

            $scope.reportModel.columnsOrder.sort(compareOrderObjects);

            var userPreferenceModel = $scope.createUserPreferenceModel(true);

            //assign ID to userPreferenceModel using reportNameChanged only if duplicate name appears
            $scope.reportNameChanged($scope.newReportName, userPreferenceModel);

            if (!$scope.isReportOverwrite) {
                userPreferenceModel.Id = 0;
            }

            UserPreferenceService.updateUserPreferenceSearch(userPreferenceModel).then(function (response) {
                toaster.pop({ type: 'success', title: 'Save complete!', body: 'Search successfully saved.', timeout: 2000 });

                $('#saveReportPopup').modal('hide');

                resetConfigurationStateTracking();

                getSavedSearches(true);
            });
        };

        $scope.createUserPreferenceModel = function (stringify) {
            var preferenceModel = angular.copy($scope.reportModel);

            if (stringify) {
                preferenceModel.columnsOrder = JSON.stringify($scope.reportModel.columnsOrder);
                preferenceModel.columnsHidden = JSON.stringify($scope.reportModel.columnsHidden);
                preferenceModel.searchTerms = JSON.stringify($scope.reportModel.searchTerms);
            }

            return preferenceModel;
        };

        $scope.toggleAllColumns = function (groupTitle, hide) {
            angular.forEach($scope.gridCols,
                function (colGroup) {
                    if (typeof groupTitle !== 'undefined' && colGroup.title !== groupTitle) {
                        return;
                    }

                    angular.forEach(colGroup.columns, function (col, i) {
                        col.hide = hide;
                        $scope.onHideColumns(col.field, col.hide);
                    });
                });

            $scope.setReportModelHiddenColumns(gridOptions.columnApi.getColumnState());
        };

        $scope.showAllColumns = function (groupTitle) {
            $scope.toggleAllColumns(groupTitle, false);
        };

        $scope.hideAllColumns = function (groupTitle) {
            $scope.toggleAllColumns(groupTitle, true);
        };

        $scope.clearConfiguration = function () {
            $('#confirmHiddenFields').modal('hide');
            $scope.reportModel.columnsHidden = $scope.originalColumnState.slice(0);
            $scope.reportModel.columnsOrder = cloneArrayOfObjects($scope.originalColumnOrderState);
            $scope.reportModel.searchTerms.sortColumn = $scope.originalSortColState.slice(0);
            $scope.reportModel.searchTerms.sortDirection = $scope.originalSortDirState.slice(0);
            $scope.columnConfigurationCleared = true;
            $scope.currentReportState = null;
            createSaveCookie(true);
        };

        $scope.getChildData = function (type, id, title) {
            $scope.searchModule = type;
            $scope.childDataParentName = title;
            $scope.childDataLoading = true;
            $('#childDataModal').modal('show');

            switch (type) {
                case 1:
                    $scope.childDataTitle = 'Line Plan Briefs';
                    //Get Lineplan briefs
                    LinePlanService.getLinePlanBriefs(id, true).then(function (data) {
                        $scope.childData = data;
                        $scope.childDataLoading = false;
                    });
                    break;
                case 2:
                    $scope.childDataTitle = 'Brief Patterns';
                    //Get Brief Patterns
                    BriefService.getBriefPatterns(id, true).then(function (data) {
                        $scope.childData = data;
                        $scope.childDataLoading = false;
                    });
                    break;
                case 3:
                    $scope.childDataTitle = 'Pattern Colorways';
                    //Get Pattern Prototypes
                    PatternService.getPatternPrototypes(id, true).then(function (data) {
                        $scope.childData = data;
                        $scope.childDataLoading = false;
                    });
                    break;
                case 4:
                    $scope.childDataTitle = 'Colorway Siblings';
                    //Get Pattern Prototypes
                    PatternService.getPatternPrototypes(id, true).then(function (data) {
                        $scope.childData = $filter('filter')(data, { PrototypeSeasonalId: '!' + id });
                    });

                    //Get Prototype Patterns
                    PrototypeService.getPrototypePatterns(id, true).then(function (prototypePatternsData) {
                        if (prototypePatternsData.length > 0) {
                            //Get Pattern Prototypes
                            PatternService.getPatternPrototypes(prototypePatternsData[0].PatternSeasonalId, true).then(function (data) {
                                $scope.childData = $filter('filter')(data, { PrototypeSeasonalId: '!' + id });
                                $scope.childDataLoading = false;
                            });
                        } else {
                            $scope.childDataLoading = false;
                        }
                    });
                    break;
            }
        };

        $scope.childDataDismiss = function () {
            $('#childDataModal').modal('hide');
        };

        $scope.sortSavedSearches = function (item) {
            var order = $scope.savedSearchPreference[1] === false ? true : false;
            //save it
            saveSortSavedSearches(item, order);

            //apply it
            setSortSavedSearches(item, order);
        }

        function setSortSavedSearches(item, order) {
            if (!item || !order) {
                var item = $scope.savedSearchPreference[0];
                var order = $scope.savedSearchPreference[1];
            }
            $scope.savedSearchPreference = [item, order];
        }

        function saveSortSavedSearches(item, order) {
            $scope.savedSearchPreference = [item, order];

            var userPreferenceModel = {
                UserPreferenceId: $scope.savedSearchPreferenceId,
                PreferenceName: "SortSavedSearches",
                model: angular.toJson($scope.savedSearchPreference)
            }

            UserPreferenceService.updateUserPreferences(userPreferenceModel).then(function (data) {
                if (!$scope.savedSearchPreferenceId)
                    $scope.savedSearchPreferenceId = data;
            });
        }

        function setPristine() {
            if ($scope.lineSearchForm) {
                $scope.lineSearchForm.$setPristine();
            }
            if ($scope.briefSearchForm) {
                $scope.briefSearchForm.$setPristine();
            }
            if ($scope.patternSearchForm) {
                $scope.patternSearchForm.$setPristine();
            }
            if ($scope.colorwaySearchForm) {
                $scope.colorwaySearchForm.$setPristine();
            }
        }

        function updateColumnListsFromGrid() {
            $scope.columnList = [];
            var columnsHidden = [];

            var allColumns = gridOptions.columnApi.getAllColumns();
            var fromLeft = 0;

            angular.forEach(allColumns, function (k) {
                fromLeft = k.visible ? k.actualWidth + fromLeft : fromLeft;
                $scope.columnList.push({ colName: k.colDef.headerName, width: k.actualWidth, visible: k.visible, fromLeft: fromLeft });
                if (!k.visible)
                    columnsHidden.push(k.colDef.field);
            });

            $scope.reportModel.columnsHidden = columnsHidden;
        }

        function defaultBrandAndSeason() {
            $scope.reportModel.searchTerms.BrandId = $scope.defaultBrandId;
            $scope.reportModel.searchTerms.SeasonId = $scope.defaultSeasonId;
            $scope.reportModel.searchTerms.DivisionKey = $scope.defaultDivisionKey;
            $scope.getSeason($scope.defaultBrandId, false);
        }

        function checkSeasonArray(seasonId) {
            for (var i = 0; i < $scope.seasons.length; i++) {
                if ($scope.seasons[i].SeasonId == seasonId) {
                    return true;
                }
            }
            return false;
        }

        function populateSearchCriteria(searchTerms) {
            for (var key in searchTerms) {
                var value = searchTerms[key];
                $scope.newReport[key] = value;
            }
            if ($scope.newReport.BrandId > 0) {
                $scope.getSeason($scope.newReport.BrandId, true);
            }
        };

        function resetConfigurationStateTracking() {
            $scope.originalSortColState = $scope.reportModel.searchTerms.sortColumn;
            $scope.originalSortDirState = $scope.reportModel.searchTerms.sortDirection;
            $scope.originalColumnOrderState = cloneArrayOfObjects($scope.reportModel.columnsOrder);
            $scope.originalColumnState = $scope.reportModel.columnsHidden.slice(0);
        }

        function cloneArrayOfObjects(array) {
            var result = [];
            for (var i = 0; i < array.length; i++) {
                result.push(angular.copy(array[i]));
            }
            return result;
        }

        function uploadDoc(file, source) {
            $scope.file = file;
            if (!$scope.file)
                return;
            var ext = $scope.file.name.substr($scope.file.name.lastIndexOf('.') + 1);
            if (ext.toLowerCase() != "xls" && ext.toLowerCase() != "xlsx") {
                toaster.pop({ type: 'error', title: 'Error!', body: "Please upload an Excel file (.xls, .xlsx)", timeout: 3000 });
                return;
            }

            if (source == 'browse-pattern') {
                PatternService.uploadMassPatternDocument($scope.file)
                    .then(function (response) {
                        toaster.pop({ type: 'success', title: 'Pattern Upload Completed', body: 'You will be notified by email when processing is complete.', timeout: 5000 });
                        clearFileSelect();
                    }, function (error, status) {
                        toaster.pop({ type: 'error', title: 'File Upload Error', body: 'There was an error while uploading your file.', timeout: 5000 });
                        clearFileSelect();
                    });
            }
            else if (source == 'browse-prototype') {
                PrototypeService.uploadMassPrototypeDocument($scope.file)
                    .then(function (response) {
                        toaster.pop({ type: 'success', title: 'Prototype Upload Completed', body: 'You will be notified by email when processing is complete.', timeout: 5000 });
                        clearFileSelect();
                    }, function (error, status) {
                        toaster.pop({ type: 'error', title: 'File Upload Error', body: 'There was an error while uploading your file.', timeout: 5000 });
                        clearFileSelect();
                    });
            }
            else if (source === 'browse-brief') {
                BriefService.uploadMassBriefDocument($scope.file)
                    .then(function (response) {
                        toaster.pop({ type: 'success', title: 'Brief Upload Completed', body: 'You will be notified by email when processing is complete.', timeout: 5000 });
                        clearFileSelect();
                    }, function (error, status) {
                        toaster.pop({ type: 'error', title: 'File Upload Error', body: 'There was an error while uploading your file.', timeout: 5000 });
                        clearFileSelect();
                    });
            }
        }

        function setScopeLevelSearchInfo(response) {

            $scope.totalRecords = response.totalRecords;
            $scope.pageSize = response.pageSize;
            $scope.pageNumber = response.currentPage;
            $scope.totalPages = response.totalPages;

            $scope.lastRecord = $scope.pageNumber == $scope.totalPages
                ? $scope.totalRecords
                : $scope.pageNumber * $scope.pageSize;

            $scope.firstRecord = $scope.pageNumber == $scope.totalPages
                ? (($scope.pageNumber - 1) * $scope.pageSize) + 1
                : $scope.lastRecord - $scope.pageSize + 1;
        }

        function setGridSorting(columnDefs) {

            var colId = $scope.reportModel.searchTerms.sortColumn;
            var sort = $scope.reportModel.searchTerms.sortDirection;

            GridUtil.setSort(columnDefs, colId, sort);
        }

        function renderGrid(gridDiv, columnDefs, searchResults) {
            gridOptions.columnDefs = columnDefs;

            if (gridDiv.children.length == 0) {
                new agGrid.Grid(gridDiv, gridOptions);
            } else {
                gridOptions.api.setColumnDefs(gridOptions.columnDefs);
            }

            gridOptions.api.setRowData(searchResults);
            gridOptions.api.hideOverlay();

            gridOptions.api.resetRowHeights();

            $scope.scrollToStart();
        }

        function handleColumnReordering(savedReport) {
            var savedColumnOrder = cloneArrayOfObjects($scope.reportModel.columnsOrder || []);
            var columnDefs = gridOptions.columnDefs;
            if (savedColumnOrder.length > 0) {
                for (var ind in savedColumnOrder) {

                    var colId = savedColumnOrder[ind].colId;
                    var colIndex = savedColumnOrder[ind].idx;

                    var index = columnDefs.map(function (e) {
                        return e.field;
                    })
                        .indexOf(colId);

                    if (index > -1) {
                        gridOptions.columnApi.moveColumn(colId, colIndex);
                        columnDefs = moveIndex(columnDefs, colIndex, colId);
                    }
                }
                //needed to update the gridCols array in col configuration
                $scope.$evalAsync();
            }
        }

        function moveIndex(arr, newIndex, colId) {
            var oldIndex = arr.map(function (e) { return e.field }).indexOf(colId);
            var obj = arr[oldIndex];
            arr.splice(oldIndex, 1);
            arr.splice(newIndex, 0, obj);
            return arr;
        }

        function compareOrderObjects(a, b) {
            const idxA = a.idx;
            const idxB = b.idx;

            var comparison = -1;
            if (idxA > idxB) {
                comparison = 1;
            } else if (idxA < idxB) {
                comparison = -1;
            }
            return comparison;
        }

        function image(params) {
            var img = document.createElement("img");
            img.src = params.value + '&access_token=' + window.encodeURIComponent($scope.currentUser.accessToken);
            return img;
        }

        function clearFileSelect() {
            model.selectDocPattern = {};
            model.selectDocProto = {};
            model.selectDocBrief = {};
            document.getElementById('file0').value = null;
            document.getElementById('file1').value = null;
            document.getElementById('file2').value = null;
        }

        function handleNavigation(event, newState, newStateParams, fromState, fromParams, element) {
            //debugger
            if ($scope.gridChanged) {
                $scope.stateChanged = !$scope.stateChanged;
                event.preventDefault();
                if (newState) {
                    $scope.pageName = newState.name;
                    if (newStateParams) {
                        $scope.pageParam = newStateParams;
                    }
                    $scope.resumeState = newState.name + "(" + JSON.stringify(newStateParams) + ")";
                    cfpLoadingBar.complete();
                } else {
                    //console.log("else")
                    //var states = $state.get();
                    //angular.forEach(states, function (k, v) {
                    //    if (newState.indexOf(k.name) > -1 && k.name.trim() !== "") {
                    //        var theState = $state.get(k.name);
                    //        if (theState.url) {
                    //            var newStateParameter = theState.url.split(':')[1];
                    //            var newStateId = newState.split(theState.name)[1].replace('/', '');
                    //            $('#confirmHiddenFields').modal({ backdrop: 'static', keyboard: false });
                    //            $('#confirmHiddenFields').modal('show');
                    //            $scope.resumeState = theState.name + '({"' + newStateParameter + '" : "' + newStateId + '"})';
                    //        }
                    //    }
                    //})
                }
                cfpLoadingBar.complete();
            }
            else {
                $('#saveReportPopup').modal('hide');

            }

            //return
            //if (stateChangeCheck() && !$scope.preventNoMore) {
            //    event.preventDefault();
            //    $scope.isPref = false;
            //    $scope.isState = true;
            //    if (newState.name) {
            //        $('#confirmHiddenFields').modal({ backdrop: 'static', keyboard: false });
            //        $('#confirmHiddenFields').modal('show');
            //        $scope.resumeState = newState.name + "(" + JSON.stringify(newStateParams) + ")";

            //        cfpLoadingBar.complete();
            //    } else {
            //        var states = $state.get();
            //        angular.forEach(states, function (k, v) {
            //            if (newState.indexOf(k.name) > -1 && k.name.trim() !== "") {
            //                var theState = $state.get(k.name);
            //                if (theState.url) {
            //                    var newStateParameter = theState.url.split(':')[1];
            //                    var newStateId = newState.split(theState.name)[1].replace('/', '');
            //                    $('#confirmHiddenFields').modal({ backdrop: 'static', keyboard: false });
            //                    $('#confirmHiddenFields').modal('show');
            //                    $scope.resumeState = theState.name + '({"' + newStateParameter + '" : "' + newStateId + '"})';
            //                }
            //            }
            //        })
            //    }
            //    $scope.preventNoMore = true;
            //}
        }

        function stateChangeCheck() {

            //If not currently viewing search results or if no original state in memory then no need to check configuration changes
            if ($scope.showGrid == false || typeof $scope.originalColumnState === 'undefined') {
                return false;
            }

            var colHiddenChanged =
                $scope.reportModel.columnsHidden.length != $scope.originalColumnState.length ? true : false;
            var colOrderChanged =
                areObjectArraysDifferent($scope.reportModel.columnsOrder, $scope.originalColumnOrderState);
            var sortColChanged =
                ($scope.reportModel.searchTerms.sortColumn !== $scope.originalSortColState);
            var sortDirChanged =
                ($scope.reportModel.searchTerms.sortDirection !== $scope.originalSortDirState);

            //Deal with edge case where user reverts sorting back to none from an original state of none
            if (sortColChanged && sortDirChanged) {
                if (($scope.reportModel.searchTerms.sortColumn == "" && !$scope.originalSortColState) || (!$scope.reportModel.searchTerms.sortColumn && $scope.originalSortColState == "")) {
                    sortColChanged = false;
                }
                if (($scope.reportModel.searchTerms.sortDirection == "" && !$scope.originalSortDirState) || (!$scope.reportModel.searchTerms.sortDirection && $scope.originalSortDirState == "")) {
                    sortDirChanged = false;
                }
            }

            return (colHiddenChanged || colOrderChanged || sortColChanged || sortDirChanged);
        }

        function areObjectArraysDifferent(arrayA, arrayB) {

            for (var i = 0; i < arrayA.length; i++) {
                if (isArrayMissingObject(arrayB, arrayA[i])) {
                    return true;
                }
            }

            for (var i = 0; i < arrayB.length; i++) {
                if (isArrayMissingObject(arrayA, arrayB[i])) {
                    return true;
                }
            }

            return false;
        }

        function isArrayMissingObject(arr, obj) {
            for (var i = 0; i < arr.length; i++) {
                if (areObjectValuesEquivalent(arr[i], obj)) {
                    return false;
                }
            }
            return true;
        }

        function areObjectValuesEquivalent(a, b) {
            if (typeof a !== 'object' && typeof b !== 'object') {
                return true;
            }

            if (typeof a !== 'object' || typeof b !== 'object') {
                return false;
            }

            var aProps = Object.getOwnPropertyNames(a);
            var bProps = Object.getOwnPropertyNames(b);

            //If number of properties is different, objects are not equivalent
            if (aProps.length != bProps.length) {
                return false;
            }

            for (var i = 0; i < aProps.length; i++) {
                var propName = aProps[i];

                //If values of same property are not equal, objects are not equivalent
                if (a[propName] !== b[propName]) {
                    return false;
                }
            }

            // If we made it this far, objects are equivalent
            return true;
        }

        function updateReportModelFromCookie() {
            clearReportModel();
            $scope.reportModel = angular.copy($localStorage.ss);
        }

        function updateReportModelFromSavedReport(savedReportModel) {
            clearReportModel();
            $scope.reportModel = angular.copy(savedReportModel);
        }

        function createSaveCookie(e) {
            $localStorage.ss = angular.copy($scope.reportModel);
            $localStorage.ss.exec = e;
        }

        function clearReportModel() {
            $scope.reportModel = angular.copy(defaultReportModel);
        }
    }
})();
